export default __webpack_public_path__ + "static/media/Belt of the Beyond.fb7919c7.jpg";